var exports = {
  "AQ": "menuButton__SLVOcR",
  "z3": "error___R4ZiD",
  "Jm": "buttonLabel__Hs_Gnx",
  "V$": "compactIcon__L1FeXT",
  "q_": "confirmationOverlay__n9-3rB",
  "RS": "confirmationHeader__EVemkb",
  "Kz": "confirmationDescription__O-iQ4F",
  "hX": "confirmationActions__lquYTf",
};

module.exports = exports;
